const types = {
  SET_SERVER_NAME: 'setServerName',
};

export default types;
